import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=90205c2a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=90205c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90205c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90205c2a')) {
      api.createRecord('90205c2a', component.options)
    } else {
      api.reload('90205c2a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=90205c2a&scoped=true&", function () {
      api.rerender('90205c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4CeaWegSqLq1y/JS/comp/PopupBox.vue"
export default component.exports